import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { calculateAge } from '../../../Registrationform/helpers/calculateAge';
import dayjs from 'dayjs';

export default function PatientInfoCard() {
  const patientDetails = useSelector(
    (state) => state.clinicalReducer.patientDetails,
  );
  const selectedPatientData = useSelector( state => state.clinicalReducer.selectedPatientData);

  const patientData = {
    patientName: patientDetails.wifeName,
    patientAge: patientDetails.wifeAge,
    patientBMI: patientDetails.patientBMI,
    patientMPI: patientDetails.patientMPI,
    husbandName: patientDetails.husbandName,
    husbandAge:patientDetails.husbandAge,
    husbandBMI: patientDetails.partnerBMI,
    husbandMPI: patientDetails.partnerMPI,
    phone: selectedPatientData.patient.phone,
  };
  let parsedDate = dayjs(selectedPatientData.patient.partner.dob);
  let husbandAge = '';
  if (!parsedDate.isValid()) {
    husbandAge = '';
  } else {
    husbandAge = calculateAge(parsedDate);
  }

  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <Card sx={{ width: '100%' }}>
          <CardContent>
            {/* Patient Details */}
            <Box display="flex" flexWrap="wrap" mb={2}>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                {/* style={{ width: '150px', display: 'inline-block' }} */}
                 <span style={{fontWeight:'bold'}}>Patient's Name:</span>  {patientData.patientName}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                 <span style={{fontWeight:'bold'}}>Age:</span> {patientData.patientAge}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>BMI:</span>
                   {patientData.patientBMI}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>MPI NO:</span>
                {patientData.patientMPI}
                </Typography>
              </Box>
            </Box>

            {/* Husband Details */}
            <Box display="flex" flexWrap="wrap" mb={2}>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                  <span style={{fontWeight:'bold'}}>Husband's Name: </span>{patientData.husbandName}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>Age: </span>
                  {husbandAge}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>BMI: </span>
                  {patientData.husbandBMI}
                </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>MPI NO: </span>
                  {patientData.husbandMPI}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" flexWrap="wrap" mb={2}>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
              <Typography variant="body1">
              <span style={{fontWeight:'bold'}}>
                Contact Details - Phone:
              </span>
                 {patientData.phone}
              </Typography>
              </Box>
              <Box width={{ xs: '100%', sm: '50%', md: '25%' }} p={1}>
                <Typography variant="body1">
                <span style={{fontWeight:'bold'}}>Email: </span>
                  {selectedPatientData.patient.email}
                </Typography>
              </Box>
              
            </Box>

            
          </CardContent>
        </Card>
      </div>
    </div>
  );
}